webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(9);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var state = {
	"person": {
		"name": "张泽互",
		"phone": "手机：15220036344",
		"email": "邮箱：845517336@qq.com",
		"profession": "专业：计算机多媒体技术",
		"school": "学历：大学专科",
		"github": "github(点击访问)",
		"url": "https://github.com/CheungZehu"
	},
	"ability": {
		"name": "掌握技能",
		"skill": [{
			"sk": "精通HTML5/CSS/JavaScript等前端技术，能快速精确还原设计稿，并且有Node.js和PHP等后台基础；；"
		}, {
			"sk": "熟练使用jQuery/Bootstrap等流行的类库，熟练使用前端MVC框架技术，如Vue.js；"
		}, {
			"sk": "理解并掌握核心技术DOM、BOM、Ajax、JSON等，熟悉页面架构和布局（栅格和响应式）；"
		}, {
			"sk": "对Web语义化有深刻理解，理解各主流浏览器间的兼容性问题，有强烈的前端性能优化意识；"
		}, {
			"sk": "熟练应用Photoshop/Adobe Illustrator等相关设计工具软件。"
		}]
	},
	"practice": {
		"name": "实习经历",
		"company": [{
			"name": "上海游唉唉网络科技有限公司广州分公司",
			"time": "2017.04.18 — 2017.05.31",
			"text": "岗位是web前端开发实习，主要参与公司前端项目开发，快速还原设计稿，编写网页视图层；协助后端工程师进行网页的视图层与后台数据对接，同时对页面样式上出现的bug进行解决。"
		}]
	},
	"education": {
		"name": "教育经历",
		"school": [{
			"year": "2014/9 — 2017/7 ",
			"school": "广东轻工职业技术学院信息技术学院 计算机多媒体专业"
		}]
	},
	"project": {
		"name": "项目经验",
		"project": [{
			"list": "iiugameH5游戏平台（HTML5+CSS3+jQuery+ThinkPHP）",
			"url": "http://h5.iiugame.com"
		}, {
			"list": "iiugame游戏官网（HTML5+CSS3+jQuery+ThinkPHP）",
			"url": "http://iiugame.com"
		}, {
			"list": "毕业设计—响应式电子商务网站（jQuery + PHP）",
			"url": "javascript:;"
		}, {
			"list": "Vdo，仿豆瓣电影APP（vue + Muse-ui）",
			"url": "https://github.com/CheungZehu/Vdo"
		}, {
			"list": "Vue版个人简历（vue）",
			"url": "https://cheungzehu.github.io/Cheung-resume/"
		}, {
			"list": "网页版俄罗斯方块小游戏（javascript）",
			"url": "https://cheungzehu.github.io/tetris/"
		}, {
			"list": "网页版2048小游戏（javascript）",
			"url": "https://cheungzehu.github.io/2048/"
		}]
	},
	"evaluation": {
		"name": "自我评价",
		"project": [{
			"list": "具备良好的学习能力，能快速学习各种前端技术。同时具备良好的分析及解决问题的能力；"
		}, {
			"list": "在校期间，成绩优秀，曾获得校内三等奖学金，加入过校学生会，担任校学生会宣传部副部长，具有一定的管理能力；"
		}, {
			"list": "个性开朗，容易相处，团队荣誉感强。"
		}]
	}
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	state: state,
	mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */],
	actions: __WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(18),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_personal__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_personal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_personal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_subject__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_subject__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Personal: __WEBPACK_IMPORTED_MODULE_0__components_personal___default.a,
    Subject: __WEBPACK_IMPORTED_MODULE_1__components_subject___default.a
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_store__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_muse_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_muse_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_muse_ui_dist_muse_ui_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_muse_ui_dist_theme_carbon_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_muse_ui_dist_theme_carbon_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_muse_ui_dist_theme_carbon_css__);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_muse_ui___default.a);

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',

  store: __WEBPACK_IMPORTED_MODULE_2__store_store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions = {
	getData: function getData(context) {
		context.commit('getData');
	}
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var mutations = {
	getData: function getData(state) {
		state.result[2].name = "1000";
	}
};

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/C.3a9d495.jpg";

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(17),
  /* scopeId */
  "data-v-376b839a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(1)(
  /* script */
  null,
  /* template */
  __webpack_require__(19),
  /* scopeId */
  "data-v-f925327c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "info"
  }, [_c('mu-list', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": __webpack_require__(14)
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$store.state.person.name))])]), _vm._v(" "), _c('mu-paper', {
    attrs: {
      "circle": ""
    }
  }), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.phone
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "call"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.email
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "email"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.profession
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "work"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.school
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "school"
    },
    slot: "left"
  })], 1)], 1), _vm._v(" "), _c('mu-paper', {
    staticClass: "bg"
  }, [_c('mu-list-item', {
    attrs: {
      "title": _vm.$store.state.person.github,
      "href": _vm.$store.state.person.url,
      "target": "_blank"
    }
  }, [_c('mu-icon', {
    attrs: {
      "value": "link"
    },
    slot: "left"
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('Personal'), _vm._v(" "), _c('Subject')], 1)
},staticRenderFns: []}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject"
  }, [_c('mu-card', {
    staticClass: "card"
  }, [_c('mu-card-title', {
    attrs: {
      "title": _vm.$store.state.ability.name
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.ability.skill), function(item) {
    return _c('mu-card-text', [_vm._v("\n\t\t\t\t\t" + _vm._s(item.sk) + "\n\t\t\t\t")])
  })], 2), _vm._v(" "), _c('mu-card', {
    staticClass: "card"
  }, [_c('mu-card-title', {
    attrs: {
      "title": _vm.$store.state.practice.name
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.practice.company), function(item) {
    return _c('mu-card-text', [_c('p', [_c('span', {
      staticClass: "company-name"
    }, [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.time))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.text))])])
  })], 2), _vm._v(" "), _c('mu-card', {
    staticClass: "card"
  }, [_c('mu-card-title', {
    attrs: {
      "title": _vm.$store.state.project.name
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.project.project), function(item) {
    return _c('mu-card-text', [_c('a', {
      attrs: {
        "href": item.url
      }
    }, [_vm._v(_vm._s(item.list))])])
  })], 2), _vm._v(" "), _c('mu-card', {
    staticClass: "card"
  }, [_c('mu-card-title', {
    attrs: {
      "title": _vm.$store.state.education.name
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.education.school), function(item) {
    return _c('mu-card-text', [_c('span', {
      staticClass: "yesr"
    }, [_vm._v(_vm._s(item.year))]), _vm._v(_vm._s(item.school) + "\n\t\t\t")])
  })], 2), _vm._v(" "), _c('mu-card', {
    staticClass: "card"
  }, [_c('mu-card-title', {
    attrs: {
      "title": _vm.$store.state.evaluation.name
    }
  }), _vm._v(" "), _vm._l((_vm.$store.state.evaluation.project), function(item) {
    return _c('mu-card-text', [_vm._v("\n\t\t\t\t" + _vm._s(item.list) + "\n\t\t\t")])
  })], 2)], 1)
},staticRenderFns: []}

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.2701cd3d16e7fd1e261a.js